import { Grid, Typography, Button } from '@material-ui/core'
import { Fragment } from 'react'
import { Field } from 'redux-form'
import ErrorMessage from '../../../../components/Error/ErrorMessage'
import {
  ReduxFormField,
  ReduxGoogleAutocomplete
} from '../../../../components/FormInput/ReduxWrappers'
import { onlyNums, noNums } from '../../../../libs/normalize/information'
import i18n from '../../../../translations/i18n'
import { MuiClasses } from '../../../../types'
import { AutocompleteOption } from '../../../../types/autocomplete'
import {
  // moreOrEqualThanFloor,
  required,
  requiredLocation,
  // lessOrEqualThanFloors,
  isPostalCode
} from '../../../../utils/validation/forms'
import { MyInput } from '../../../NewApplication/Fields'
import Suggest from '../../Stepper/Steps/Suggest'
import SubmitButton from '../../Stepper/SubmitButton'

interface AddressinfoFieldProps {
  t: i18n.TFunction
  currentStep: any
  isDisabled: boolean
  changeFormValue: (field: string, value: string) => void
  autocompleteLocation?: AutocompleteOption | string
  classes: MuiClasses
  addressInfoValues: any
  doStepBack: () => void
  error: string
}

const AddressInfoFields = ({
  t,
  isDisabled,
  changeFormValue,
  autocompleteLocation,
  currentStep,
  classes,
  addressInfoValues,
  doStepBack,
  error
}: AddressinfoFieldProps) => {
  return (
    <Grid container>
      {currentStep === 4 && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Grid className={classes.largeForm} container spacing={1}>
                {' '}
                <Grid item sm={12}>
                  <Typography variant='h5' gutterBottom>
                    {t('apartment.addressInfo')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body1' gutterBottom>
                    {t('apartment.streetAddress')}
                  </Typography>
                  <Field
                    fullWidth
                    name='autocompleteLocation'
                    selectLabel={t('autocomplete.select')}
                    existingLocations={[]}
                    placeholder={t('autocomplete.placeholder')}
                    changeFormValue={changeFormValue}
                    streetNumberFormValue={addressInfoValues?.streetNumber}
                    component={ReduxGoogleAutocomplete}
                    validate={[requiredLocation]}
                    required
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <Typography variant='body1' gutterBottom>
                    {t('person.buildingLetter')}
                  </Typography>
                  <ReduxFormField
                    name='buildingLetter'
                    disabled={isDisabled}
                    component={MyInput}
                    style={{
                      width: '100%',
                      height: '58px',
                      padding: '20px',
                      background: '#E7ECEF'
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' gutterBottom>
                    {t('person.apartmentNumber')}
                  </Typography>
                  <ReduxFormField
                    name='apartmentNumber'
                    disabled={isDisabled}
                    normalize={onlyNums}
                    component={MyInput}
                    style={{
                      width: '100%',
                      height: '58px',
                      padding: '20px',
                      background: '#E7ECEF'
                    }}
                    type='number'
                  />
                </Grid> */}
                <Fragment>
                  <Grid item xs={12} sm={4}>
                    <Typography variant='body1' gutterBottom>
                      {t('person.postalCode')}
                    </Typography>
                    <ReduxFormField
                      name='postalCode'
                      normalize={onlyNums}
                      min={0}
                      validate={[required, isPostalCode]}
                      disabled={isDisabled}
                      required
                      component={MyInput}
                      style={{
                        width: '100%',
                        height: '58px',
                        padding: '20px',
                        background: '#E7ECEF'
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Typography variant='body1' gutterBottom>
                      {t('person.postalArea')}
                    </Typography>
                    <ReduxFormField
                      name='postalArea'
                      normalize={noNums}
                      validate={[required]}
                      disabled={isDisabled}
                      component={MyInput}
                      style={{
                        width: '100%',
                        height: '58px',
                        padding: '20px',
                        background: '#E7ECEF'
                      }}
                      required
                    />
                  </Grid>
                </Fragment>
                {/* <Grid item xs={6}>
                  <Typography variant='body1' gutterBottom>
                    {t('apartment.floor')}
                  </Typography>
                  <ReduxFormField
                    name='floor'
                    type='number'
                    normalize={onlyNums}
                    inputProps={{ step: 1 }}
                    validate={[lessOrEqualThanFloors]}
                    disabled={isDisabled}
                    component={MyInput}
                    style={{
                      width: '100%',
                      height: '58px',
                      padding: '20px',
                      background: '#E7ECEF'
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant='body1' gutterBottom>
                    {t('apartment.floors')}
                  </Typography>
                  <ReduxFormField
                    name='floors'
                    normalize={onlyNums}
                    inputProps={{ min: 0, step: 1 }}
                    validate={[moreOrEqualThanFloor]}
                    disabled={isDisabled}
                    component={MyInput}
                    style={{
                      width: '100%',
                      height: '58px',
                      padding: '20px',
                      background: '#E7ECEF'
                    }}
                  />
                </Grid> */}
              </Grid>
              <ErrorMessage error={error} />
              <Grid container style={{ maxWidth: '560px', marginTop: ' 15px' }}>
                <Grid item xs={4}>
                  <Button
                    disabled={currentStep === 0}
                    onClick={doStepBack}
                    style={{ width: '100%', height: '42px' }}
                  >
                    {t('general.back')}
                  </Button>
                </Grid>
                <Grid item xs={8}>
                  <SubmitButton t={t} submit={true} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={6} md={12} sm={12} xs={12}>
              <div className={classes.infoBoxWrapper}>
              <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step7Hint')}
                containerMaxWidth='550px'
                contentMaxWidth='450px'
              />
              </div>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default AddressInfoFields


